var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7915 2.26617C11.9795 2.09574 12.2343 2 12.5 2C12.7657 2 13.0205 2.09574 13.2085 2.26617L18.2187 6.81167C18.4012 6.98313 18.5022 7.21277 18.5 7.45113C18.4977 7.6895 18.3923 7.91751 18.2065 8.08606C18.0207 8.25462 17.7694 8.35023 17.5067 8.3523C17.2439 8.35437 16.9908 8.26274 16.8018 8.09714L13.5021 5.10347V21.0909C13.5021 21.332 13.3965 21.5632 13.2086 21.7337C13.0206 21.9042 12.7658 22 12.5 22C12.2342 22 11.9794 21.9042 11.7914 21.7337C11.6035 21.5632 11.4979 21.332 11.4979 21.0909V5.10347L8.19819 8.09714C8.0092 8.26274 7.75608 8.35437 7.49335 8.3523C7.23061 8.35023 6.97928 8.25462 6.79349 8.08606C6.60771 7.91751 6.50232 7.6895 6.50004 7.45113C6.49775 7.21277 6.59876 6.98313 6.78129 6.81167L11.7915 2.26617Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.56398cc854faa7b1b2ec5c60b32f0e20.svg";
export { ForwardRef as ReactComponent };